const ForgotPasswordFormFields = {
  email: {
    id: 'email',
    name: 'Email',
    label: 'forgot.pass.form.email.label'
  }
};

export default ForgotPasswordFormFields;
